import { graphql, useStaticQuery } from 'gatsby';

export const useDefaultMenu = (locale: string) => {
  const dataMenu = useStaticQuery(graphql`
    query HeaderQuery {
      fr: datoCmsMenu(locale: "fr") {
        ...Menu
      }
      en: datoCmsMenu(locale: "en") {
        ...Menu
      }
      es: datoCmsMenu(locale: "es") {
        ...Menu
      }
    }
  `);

  const menu = dataMenu[locale];

  return menu;
};
